skrilla.controller('splitsCtrl', function ($scope, cacheService, modalService) {
    $scope.contest = cacheService.getObject("contest");
    $scope.splits = $scope.contest.splits;
    $scope.reset = function(){
        $scope.splits.length = 0;
        $scope.splits.push({toPosition: 1, percent: 100});
    }
    if($scope.splits.length === 0){
        $scope.reset();
    }
    $scope.getFrom = function(i) {
        return $scope.splits[i] && i > 0 ? parseInt($scope.splits[i - 1].toPosition) + 1 : 0;
    }

    $scope.add = function(){
        $scope. splits.push({toPosition: $scope.splits[$scope.splits.length -1].toPosition + 2})
    }

    $scope.ok = function(){
        modalService.dismissAll();
    }

    $scope.getAmount = function (i) {
        if($scope.splits[i]) {
            var amount = $scope.splits[i] && $scope.splits[i].percent ? ($scope.contest.prizePool / 100) * $scope.splits[i].percent : 0;
            var from = $scope.getFrom(i);
            from = from === 0 ? 0 : from - 1;
            var posCount = ($scope.splits[i].toPosition - from);
            amount /= posCount;
            $scope.splits[i].positionCount = posCount;
            $scope.splits[i].amount = amount;
            $scope.splits[i].fromPosition = from;
            return "$" + amount;
        }
    }

    $scope.getTotalPercent = function(){
        if($scope.splits.length === 0) return;
        var amount = 0;
        for(var i = 0; i < $scope.splits.length; i ++){
            if($scope.splits[i].percent === undefined || $scope.splits[i].percent === null){
                $scope.splits[i].percent = ($scope.splits[i].amount / ($scope.contest.prizePool / 100));
            }
            $scope.splits[i].percent = parseInt($scope.splits[i].percent);
            if(amount < 100) {
                if (amount + $scope.splits[i].percent >= 100) {
                    removeRest(i);
                    $scope.splits[i].percent = parseInt(100 - amount);
                    amount = 100;
                }
                else{
                    amount += parseInt($scope.splits[i].percent);
                }
            }
        }
        if(amount < 100 && amount > 0){
            var to = $scope.splits.length > 1 ? $scope.getFrom($scope.splits.length - 1) : $scope.splits[0].toPosition;
            $scope.splits.push({toPosition: to + 1, percent: parseInt(100 - amount)})
        }
    }


    function removeRest(i){
        $scope.splits.splice(i + 1, $scope.splits.length - i);
    }


});